import React, { useState } from "react";
import { toast } from "react-toastify";
import { logout } from "../utils/Auth";
import Maxcode from "../assets/maxcode.png";
import { NavLink, Link, useNavigate } from "react-router-dom";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";

type LayoutProps = {
  children: React.ReactNode;
  title?: string;
  breadcrumbTitle?: string;
};

const Layout: React.FC<LayoutProps> = ({
  children,
  title,
  breadcrumbTitle,
}) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [barcodeSubmenuOpen, setBarcodeSubmenuOpen] = useState(true);

  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const username = user?.name;

  const handleLogout = () => {
    logout();
    navigate("/login");
    toast.info("Anda telah logout", { position: "top-right" });
  };

  return (
    <div className="flex h-screen bg-gray-100">
      <aside
        className={`fixed md:relative z-40 h-full bg-gray-800 text-white transition-all duration-300 ${
          sidebarOpen ? "w-64" : "w-16"
        } ${mobileMenuOpen ? "block" : "hidden"} md:block`}
      >
        <div className="flex items-center justify-between bg-white p-3">
          <img
            src={Maxcode}
            alt="logo"
            className={`${!sidebarOpen ? "w-8 h-8" : "w-[32px]"}`}
          />
          {sidebarOpen && <p className="font-bold text-black">MAXCODE</p>}

          <button
            onClick={() => setSidebarOpen(!sidebarOpen)}
            className="hidden md:block text-black"
          >
            {sidebarOpen ? (
              <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 20 20">
                <path
                  fillRule="evenodd"
                  d="M6.293 5.293a1 1 0 011.414 0L10 
                  7.586l2.293-2.293a1 1 0 111.414 1.414l-3 
                  3a1 1 0 01-1.414 0l-3-3a1 1 0 
                  010-1.414z"
                  clipRule="evenodd"
                />
              </svg>
            ) : (
              <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 20 20">
                <path
                  fillRule="evenodd"
                  d="M3 5h14a1 1 0 110 
                  2H3a1 1 0 110-2zM3 10h14a1 1 0 
                  110 2H3a1 1 0 110-2zM3 15h14a1 1 
                  0 110 2H3a1 1 0 110-2z"
                  clipRule="evenodd"
                />
              </svg>
            )}
          </button>

          <button
            onClick={() => setMobileMenuOpen(false)}
            className="md:hidden text-black"
          >
            ✕
          </button>
        </div>

        <nav className="mt-4">
          <div>
            <button
              onClick={() => setBarcodeSubmenuOpen(!barcodeSubmenuOpen)}
              className="w-full flex items-center px-4 py-2 hover:bg-gray-700"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className={`w-6 h-6 ${!sidebarOpen && "mx-auto"}`}
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 6h16M4 10h16M4 14h16M4 18h16"
                />
              </svg>
              {sidebarOpen && (
                <div className="flex justify-between items-center w-full ml-2">
                  <span>Barcode</span>
                  <svg
                    className={`w-4 h-4 transform transition-transform ${
                      barcodeSubmenuOpen ? "rotate-180" : ""
                    }`}
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M5.293 7.293a1 1 0 011.414 
                      0L10 10.586l3.293-3.293a1 1 0 
                      111.414 1.414l-4 4a1 1 0 
                      01-1.414 0l-4-4a1 1 0 
                      010-1.414z"
                      clipRule="evenodd"
                    />
                  </svg>
                </div>
              )}
            </button>

            {barcodeSubmenuOpen && (
              <ul className="mt-1 space-y-1">
                <li>
                  <NavLink
                    to="/receive"
                    className={({ isActive }) =>
                      `flex items-center px-6 py-2 text-sm ${
                        isActive
                          ? "bg-gray-700 border-l-4 border-blue-500"
                          : "hover:bg-gray-700"
                      }`
                    }
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="w-5 h-5 mr-2"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M8 4H6a2 2 0 00-2 
                        2v12a2 2 0 002 
                        2h12a2 2 0 002-2V6a2 2 0 
                        00-2-2h-2m-4-1v8m0 0l3-3m-3 
                        3L9 8"
                      />
                    </svg>
                    {sidebarOpen && "Receive"}
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/"
                    className={({ isActive }) =>
                      `flex items-center px-6 py-2 text-sm ${
                        isActive
                          ? "bg-gray-700 border-l-4 border-blue-500"
                          : "hover:bg-gray-700"
                      }`
                    }
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="w-5 h-5 mr-2"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M17 17h2a2 2 0 002-2v-4a2 2 
                        0 00-2-2H5a2 2 0 
                        00-2 2v4a2 2 0 
                        002 2h2m2 4h6a2 2 
                        0 002-2v-4a2 2 
                        0 00-2-2H9a2 2 0 
                        00-2 2v4a2 2 0 
                        002 2zm8-12V5a2 2 
                        0 00-2-2H9a2 2 0 
                        00-2 2v4h10z"
                      />
                    </svg>
                    {sidebarOpen && "Print"}
                  </NavLink>
                </li>
                <li>
                  <NavLink
                    to="/import-item"
                    className={({ isActive }) =>
                      `flex items-center px-6 py-2 text-sm ${
                        isActive
                          ? "bg-gray-700 border-l-4 border-blue-500"
                          : "hover:bg-gray-700"
                      }`
                    }
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="w-5 h-5 mr-2"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12"
                      />
                    </svg>
                    {sidebarOpen && "Import Item"}
                  </NavLink>
                </li>
              </ul>
            )}
          </div>

          <NavLink
            to="/accurate-posting"
            className={({ isActive }) =>
              `flex items-center px-4 py-2 hover:bg-gray-700 ${
                isActive ? "bg-gray-700 border-l-4 border-blue-500" : ""
              }`
            }
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              className="w-6 h-6 mr-2"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M12 16V8m0 0-3 3m3-3 3 3M6 18a4 4 0 0 1-.874-7.903A6.002 6.002 0 0 1 16.66 8.12 4.5 4.5 0 1 1 18 18H6z"
              />
            </svg>
            {sidebarOpen && "Generate Serial Number"}
          </NavLink>
        </nav>
      </aside>

      <div className="flex flex-col flex-1">
        <header className="flex items-center justify-between bg-white px-4 py-3 shadow">
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden text-gray-700"
          >
            ☰
          </button>
          <h1 className="text-lg font-bold">{title}</h1>

          <div className="relative">
            <button
              onClick={() => setDropdownOpen(!dropdownOpen)}
              className="flex items-center space-x-2"
            >
              <div className="w-8 h-8 rounded-full bg-gray-400 flex items-center justify-center">
                <span className="text-sm font-medium">
                  {username?.charAt(0).toUpperCase() || "-"}
                </span>
              </div>
              <span className="hidden sm:block">{username || ""}</span>
            </button>

            {dropdownOpen && (
              <div className="absolute right-0 mt-2 bg-white border rounded shadow w-48">
                <button
                  onClick={handleLogout}
                  className="w-full text-left px-4 py-2 hover:bg-gray-100 text-sm"
                >
                  Logout
                </button>
              </div>
            )}
          </div>
        </header>

        <div className="bg-gray-100 px-4 py-2 text-sm">
          <ol className="flex space-x-2">
            <li>
              <Link to="/" className="text-blue-600 hover:underline">
                Barcode
              </Link>
            </li>
            <li>/</li>
            <li className="text-gray-600">{breadcrumbTitle || "-"}</li>
          </ol>
        </div>

        <main className="flex-1 overflow-y-auto p-4">
          <DndProvider
            context={typeof window !== "undefined" ? window : undefined}
            backend={HTML5Backend}
          >
            {children}
          </DndProvider>
        </main>
      </div>
    </div>
  );
};

export default Layout;
